import { render, staticRenderFns } from "./DataOrderForeignWork.vue?vue&type=template&id=1c6320e0&scoped=true"
import script from "./DataOrderForeignWork.vue?vue&type=script&lang=js"
export * from "./DataOrderForeignWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6320e0",
  null
  
)

export default component.exports